/**
 * Fix scale zoom on IOS when open keyboard
 * @todo need refactor for unit test ? + test on device
 * @author corsor
 */
class UiScaleAccessibility {
	constructor() {
		this.meta = document.querySelector('meta[name=viewport]') || []
		this.scales = [1, 1]
		this.callback = this.fixScaleZoom.bind(this)
		this.init()
	}

	init() {
		if (this.meta && yTos.Cartier.isIOS()) {
			this.fixScaleZoom()
			this.scales = [0.25, 1.6]

			document.addEventListener('gesturestart', this.fixScaleZoom.bind(this), {
				once: true,
				capture: true,
				passive: true,
			})
		}
	}

	fixScaleZoom() {
		this.meta.content = `width=device-width,minimum-scale=${this.scales[0]},maximum-scale=${this.scales[1]}`
		// document.removeEventListener('gesturestart', this.fixScaleZoom, true)
	}
}

export default UiScaleAccessibility
